import { Coordinate } from './Coordinate'
import { UnitStatus } from './UnitStatus'

export const booleanFromJSONValue = (value: any): boolean => {
  if (!value) {
    return false
  } else if (typeof value == 'boolean') {
    return value
  } else if (typeof value == 'string') {
    return value === '1'
  }
  return false
}

export const stringOptionalFromJSONValue = (value: any): string | undefined => {
  if (!value) {
    return undefined
  } else if (typeof value == 'number') {
    return value.toString()
  } else if (typeof value == 'string') {
    return value
  }
  return undefined
}

export const stringFromJSONValue = (value: any): string => {
  if (!value) {
    return ''
  } else if (typeof value == 'number') {
    return value.toString()
  } else if (typeof value == 'string') {
    return value
  }
  return ''
}

export const intFromJSONValue = (value: any): number => {
  if (!value) {
    return 0
  } else if (typeof value == 'number') {
    return Math.floor(value)
  } else if (typeof value == 'string') {
    return parseInt(value)
  }
  return 0
}

export const intOptionalFromJSONValue = (value: any): number | undefined => {
  if (!value) {
    return undefined
  } else if (typeof value == 'number') {
    return Math.floor(value)
  } else if (typeof value == 'string') {
    return parseInt(value)
  }
  return undefined
}

export const floatFromJSONValue = (value: any): number => {
  if (!value) {
    return 0
  } else if (typeof value == 'number') {
    return value
  } else if (typeof value == 'string') {
    return parseFloat(value)
  }
  return 0
}

export const dateOptionalFromJSONValue = (value: any): Date | undefined => {
  if (typeof value == 'string') {
    const date = new Date(value)
    if (date instanceof Date && !isNaN(date.getTime())) {
      return date
    }
  }
  return undefined
}

export const stringArrayFromJSONValue = (value: any): string[] => {
  if (Array.isArray(value)) {
    return value.map(v => stringFromJSONValue(v))
  }
  return []
}

export const intArrayFromJSONValue = (value: any): number[] => {
  if (Array.isArray(value)) {
    return value.map(v => intFromJSONValue(v))
  }
  return []
}

export const coordinateFromJSONValue = (value: any): Coordinate => {
  if (typeof value === 'string') {
    const parts = value.split(',')
    if (parts.length === 2) {
      return { lat: floatFromJSONValue(parts[0]), lng: floatFromJSONValue(parts[1]) }
    }
  }
  return { lat: 0, lng: 0 }
}

export const coordinateFromJSONValues = (latValue: any, longValue: any): Coordinate => {
  return { lat: floatFromJSONValue(latValue), lng: floatFromJSONValue(longValue) }
}

export const arrayFromJSONValue = (value: any): any[] => {
  if (Array.isArray(value)) {
    return value
  }
  return []
}

export const unitStatusFromJSONValue = (value: any): UnitStatus => {
  const str = stringFromJSONValue(value)
  switch (str) {
    case 'DP':
    case 'AK':
    case 'ER':
    case 'SG':
    case 'OS':
    case 'AE':
    case 'TR':
    case 'TA':
      return str as UnitStatus
  }
  return 'AR'
}

export const fileURLFromJSONValue = (value: any, fileExtension: string): string => {
  const file = stringFromJSONValue(value)
  if (file.startsWith('https://')) {
    return file
  }
  const partialFileURI = file.replace(/^\/+/, '').replace(/\/+$/, '')
  return partialFileURI == '' ? '' : `${partialFileURI}.${fileExtension}`
}

export const fileExtensionForType = (type: string) => {
  switch (type) {
    case 'image/png':
      return 'png'
    case 'image/jpeg':
      return 'jpg'
    case 'application/pdf':
      return 'pdf'
    case 'application/x-mpegURL':
      return 'm3u8'
  }
  return ''
}
